import { assertNotEmpty, dateUtils } from '@festina-life/core'
import { Tooltip } from '@festina-life/ui/feedback'

import { useUntilChangesetKeyValue } from '../../context/useUntilChangesetKeyValue'
import type { TemplateVersionInfo } from '../../types/templateModel'
import { NO_DATE_SYMBOL } from '../../util/constants'
import { MutipleVersionCircles } from '../versionedTimeline/MutipleVersionCircles'
import type { useTimelineScale } from '../versionedTimeline/useTimelineScale'
import { TemplateVersionTooltipContent } from './TemplateVersionTooltipContent'
import { useIsTemplateVersionActive } from './useIsTemplateVersionActive'

type Props = {
  currentVersionLineId: string
  dateToPixel: ReturnType<typeof useTimelineScale>['dateToPixel']
  versions: TemplateVersionInfo[]
}

export const MultipleTemplateVersionsCircle = ({
  currentVersionLineId,
  dateToPixel,
  versions,
}: Props) => {
  const untilChangesetKeyValue = useUntilChangesetKeyValue()
  const isAnyVersionLockedToChangeset =
    !!untilChangesetKeyValue &&
    versions.some(
      (version) =>
        untilChangesetKeyValue === version.changesetHistory?.changesetKey,
    )
  const checkIsVersionActive = useIsTemplateVersionActive(currentVersionLineId)
  const isAnyVersionActive = versions.some((version) =>
    checkIsVersionActive(version),
  )
  const firstVersion = versions[0]
  assertNotEmpty(firstVersion)

  const leftPosition = dateToPixel(
    firstVersion.fromDate
      ? dateUtils.dateUtcAsLocal(firstVersion.fromDate).toDate()
      : NO_DATE_SYMBOL,
  )

  return (
    <Tooltip
      tip={
        <TemplateVersionTooltipContent
          versions={versions}
          versionId={currentVersionLineId}
        />
      }
      isInteractive
    >
      <g>
        <MutipleVersionCircles
          count={versions.length}
          left={leftPosition}
          isAnyVersionLockedToChangeset={isAnyVersionLockedToChangeset}
          isAnyVersionActive={isAnyVersionActive}
        />
      </g>
    </Tooltip>
  )
}
